import React from 'react';
import PropTypes from 'prop-types';
import { AlertBase as Alert } from '@tfecom-thermofisher/react-komodo-design';
import { Message } from 'src/core/components';

import Circle from './Circle';
import messages from './messages';
import './PlateDisplay.style.scss';

const PlateDisplayComponent = ({ plateSize, wellsMatrixConfig, onWellClick, condensed }) => {
  if (!plateSize) {
    return (
      <Alert type="error" data-testid=" well-matrix-warning ">
        <Message message={messages.cannotProperlyDisplayPlateWells} />
      </Alert>
    );
  }

  return (
    <div data-testid="wells-matrix">
      {wellsMatrixConfig.map((rowItem, rowItemIdx) => (
        <div className="wells-row">
          {rowItem.map((well, colItemIdx) => (
            <Circle
              key={`${well?.row}${well?.column}`}
              // first row, has circle top border and column number above the circle
              topContent={rowItemIdx === 0 ? wellsMatrixConfig[rowItemIdx][colItemIdx].column : ''}
              // first column has circle with left border and row letter left og the circle
              leftContent={colItemIdx === 0 ? wellsMatrixConfig[rowItemIdx][colItemIdx].row : ''}
              // last row has bottom border
              hasBottomBorder={rowItemIdx === wellsMatrixConfig.length - 1}
              // last column has right border
              hasRightBorder={colItemIdx === rowItem.length - 1}
              well={well}
              onClick={onWellClick}
              condensed={condensed}
            />
          ))}
        </div>
      ))}
    </div>
  );
};

PlateDisplayComponent.propTypes = {
  wellsMatrixConfig: PropTypes.array,
  plateSize: PropTypes.number,
  onWellClick: PropTypes.func.isRequired,
  condensed: PropTypes.bool.isRequired,
};

export default PlateDisplayComponent;
